document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('#hc-line-attributes-wrapper');
  const formSelector = wrapper.dataset.targetForm;
  const form = document.querySelector(formSelector);

  if (!form) return;

  const inputs = wrapper.querySelectorAll('.line-attribute');

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      const name = input.dataset.name;
      const hiddenInput = form.querySelector(`[name="properties[${name}]"]`);
      if (hiddenInput) {
        hiddenInput.value = input.value;
      }
    });
  });
});